import styled from "styled-components";

export const PlansContainer = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 24px;
  margin-bottom: 60px;
  justify-content: flex-start;
`;
